import React, { useEffect } from "react";
import { useOnlineStatus } from "../../hook/use-online-status";
import { Backdrop, CircularProgress, Paper, Typography } from "@mui/material";
import { WifiOff } from "@mui/icons-material";

const OfflineNotification: React.FC = () => {
  const isOnline = useOnlineStatus();

  useEffect(() => {
    if (!isOnline) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOnline]);

  if (isOnline) {
    return null;
  }

  return (
    <Backdrop
      sx={(theme) => ({
        color: "#fff",
        zIndex: theme.zIndex.drawer + 1,
        height: "100vh",
        width: "100vw",
      })}
      open={!isOnline}
    >
      <Paper
        sx={{
          p: 3,
          maxWidth: 400,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <WifiOff
          sx={{
            fontSize: 55,
            color: "#7a7a7a",
          }}
        />

        <Typography
          sx={{
            fontSize: 26,
            fontWeight: 600,
            color: "#111",
          }}
        >
          Connection lost
        </Typography>

        <Typography
          sx={{
            fontSize: 18,
            color: "#8a8a8a",
          }}
        >
          Attempting to reconnect...
        </Typography>

        <CircularProgress
          size={50}
          thickness={3.2}
          sx={{
            color: "#d2d2d2",
          }}
        />

        <Typography
          sx={{
            fontSize: 18,
            lineHeight: 1.2,
            color: "#8a8a8a",
          }}
        >
          Please check your internet connection
        </Typography>
      </Paper>
    </Backdrop>
  );
};

export default OfflineNotification;
